import React, { useState, useEffect } from 'react';

const MobileCapabilityWarning = ({ onDismiss }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Always show the warning on mobile (no localStorage check)
    setIsVisible(true);
  }, []);

  const handleDismiss = () => {
    sessionStorage.setItem('mobileWarningDismissed', 'true');
    setIsVisible(false);
    onDismiss();
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px'
        }}
        onClick={handleDismiss}
      >
        {/* Modal */}
        <div
          style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            padding: '24px',
            maxWidth: '500px',
            width: '100%',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
            animation: 'slideIn 0.3s ease-out'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>📱</div>
            <h2 style={{
              fontSize: 'var(--text-xl)',
              fontWeight: 'bold',
              color: '#1F2937',
              margin: '0 0 12px 0'
            }}>
              Mobile View Mode
            </h2>
          </div>

          <div style={{
            fontSize: 'var(--text-base)',
            lineHeight: '1.6',
            color: '#4B5563',
            marginBottom: '20px'
          }}>
            <p style={{ marginBottom: '12px' }}>
              You're viewing SkipEye on a mobile device. The mobile version provides <strong>view-only</strong> access to help you quickly check skip locations and details.
            </p>

            <div style={{
              backgroundColor: '#FEF3C7',
              border: '1px solid #F59E0B',
              borderRadius: '8px',
              padding: '12px',
              marginBottom: '12px'
            }}>
              <strong style={{ color: '#92400E' }}>Limited Features:</strong>
              <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px', color: '#92400E' }}>
                <li>No editing or adding records</li>
                <li>No deleting skips</li>
                <li>Records page not available</li>
              </ul>
            </div>

            <p style={{ marginBottom: 0 }}>
              For full functionality including editing, adding, and deleting records, please use a desktop device.
            </p>
          </div>

          <button
            onClick={handleDismiss}
            style={{
              width: '100%',
              padding: '14px 24px',
              backgroundColor: '#3B82F6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: 'var(--text-base)',
              fontWeight: '600',
              cursor: 'pointer',
              minHeight: '48px',
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2563EB'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3B82F6'}
          >
            I Understand
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(-20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </>
  );
};

export default MobileCapabilityWarning;
